import { MessageBox, Message } from "element-ui";

export function handleConfirm(text, type) {
  return MessageBox.confirm(text, "操作确认", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: type
  });
}

/**
 *
 * @param text
 * @param type
 * @returns {Promise<boolean>}
 */
export function isHandleConfirm(text, type) {
  return new Promise(resolve => {
    handleConfirm(text, type)
      .then(() => {
        resolve(true);
      })
      .catch(err => {
        resolve(false);
      });
  });
}

/**
 * @author 封装 element-ui 消息提示
 * @param text
 * @param type
 * @returns {Promise}
 */
export function handleAlert(text, type) {
  return Message({
    showClose: true,
    message: text,
    type: type
  });
}
